<div *ngIf="isAuthenticated" class="col-md-12 header-part">
  <app-header></app-header>
  <div class="env-banner {{ currentEnvironment }}" *ngIf="isEnvBannerOpen" style="background-color: red;">
    <div class="env-text justify-content-center">
       <ng-container *ngIf="isProdEnv" >
        <marquee direction="left" >
          Smartphone eligibility and ordering features will be temporarily unavailable from June 1 to June 6, 2025, due to the HXM storefront cutover. During this period, the order module will display static data. The banner will be removed once the functionality is restored.
        </marquee>
      </ng-container> 
      <ng-container *ngIf="!isProdEnv">
       <marquee direction="left" >
         Smartphone eligibility and ordering features will be temporarily unavailable from June 1 to June 6, 2025, due to the HXM storefront cutover. During this period, the order module will display static data. The banner will be removed once the functionality is restored.
        </marquee>
      </ng-container>
    </div>
    <div class="env-close" *ngIf="!isProdEnv" (click)="toggleEnvBanner()">
      <i class="fa fa-times"></i>
    </div>
  </div>
  <div class="copied-alert" #copiedAlert>
    <i class="fa fa-check-circle"></i>&nbsp; Copied!
  </div>
</div>
<app-shell></app-shell>